module.exports = {
      id: "magazines-usage",
      viewBox: "0 0 25.36 20.288",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#magazines",
      toString: function () {
        return this.url;
      }
    }